import React from 'react';
import { Button } from './ui/button';
import { Check } from 'lucide-react';

const CHECKOUT_URL = 'https://pay.routerfy.com/c/01k9qtctgem89zzktgpvzw6d0f';

export const FIPHero = () => {
  const badges = [
    '100% online',
    'Aulas curtas e objetivas',
    'Certificado NBZ Educação'
  ];

  return (
    <section className="hero-section pt-32 pb-20 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="container-fip">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text */}
          <div className="space-y-8">
            <h1 className="text-5xl lg:text-6xl font-bold text-primary leading-tight">
              Transforme sua experiência em obras em uma especialização que o mercado respeita.
            </h1>
            <p className="text-2xl text-gray-700 leading-relaxed">
              Aprenda na prática o que diferencia quem executa de quem domina a impermeabilização.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Curso FIP – Formação de Impermeabilizador na Prática. Da teoria à execução real em obra — o treinamento completo para se tornar referência técnica e aumentar seus resultados.
            </p>
            
            {/* Badges */}
            <div className="flex flex-wrap gap-4">
              {badges.map((badge, index) => (
                <div key={index} className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-md border border-blue-100">
                  <Check className="w-5 h-5 text-accent" />
                  <span className="text-primary font-medium">{badge}</span>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <div>
              <Button 
                size="lg" 
                className="bg-accent hover:bg-accent-hover text-primary font-bold text-xl px-10 py-8 rounded-xl shadow-xl cta-pulse transform hover:scale-105 transition-all duration-300"
                onClick={() => window.open(CHECKOUT_URL, '_blank')}
              >
                Quero garantir minha vaga agora
              </Button>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="relative">
            <div className="aspect-square rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
              <img 
                src="./Image.png" 
                alt="Profissional realizando impermeabilização em obra"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-accent/20 rounded-full blur-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};